import { render, staticRenderFns } from "./ModalShareKiosk.vue?vue&type=template&id=0732e98a&scoped=true&lang=pug"
import script from "./ModalShareKiosk.vue?vue&type=script&lang=js"
export * from "./ModalShareKiosk.vue?vue&type=script&lang=js"
import style0 from "./ModalShareKiosk.vue?vue&type=style&index=0&id=0732e98a&prod&lang=scss&scoped=true"
import style1 from "./ModalShareKiosk.vue?vue&type=style&index=1&id=0732e98a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732e98a",
  null
  
)

export default component.exports